export const SET_AGENTS = 'SET_AGENTS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_ALL_TOTAL = 'SET_ALL_TOTAL';

export const FETCH_AGENTS = 'FETCH_AGENTS'
export const FETCH_AGENT_INFO = 'FETCH_AGENT_INFO'

